module.exports = __webpack_public_path__ + "static/media/WS.23625f54.svg";